import { Progress } from "antd";
import React from "react";
import { cashConverter } from "../../../../utils";
import FundingSplitChart from "./FundingSplitChart";
import AcresImpactChart from "./AcresImpactChart";

function InvestmentBreakdown() {
  const items = [
    {
      title: "Acres Supported",
      cost: 75,
    },
    {
      title: "Cost per Acre",
      cost: 1337500.0,
    },
    {
      title: "Govt Expected Contribution",
      cost: 150000000.0,
    },
    {
      title: "Your Share",
      cost: 100000000.0,
    },
  ];

  return (
    <div className="lg:mt-[2.5rem] mt-[1rem] lg:p-[2.5rem] p-3 rounded-[1rem] bg-white">
      <div className="text-[#1A1A1A] font-sora text-[1.25rem] font-[600] leading-[1.5rem]">
        Your Investment Breakdown
      </div>
      <div className="mt-[2.16rem] lg:w-[50%] w-full">
        <div className="text-[#424242] font-[400] text-[.875rem] font-sora leading-[1.5rem]">
          Pathway Progress Impact
        </div>
        <Progress percent={30} fill="#0092CC" />
      </div>

      <div className="grid lg:grid-cols-2 grid-cols-1 gap-[2rem] mt-[2rem]">
        <div className="grid lg:grid-cols-2 grid-cols-1 gap-[.5rem]">
          {items &&
            items?.map((item) => (
              <div className="bg-[#F1F3F5] rounded-[.75rem] py-[1rem] px-[2rem] lg:max-h-[6.875rem] h-full">
                <div className="text-[#424242] text-[.875rem] font-sora font-[400] leading-[1.5rem]">
                  {item?.title}
                </div>
                <div className="text-[#1A1A1A] text-[1.25rem] font-interSans font-[600]">
                  {cashConverter(item?.cost)}
                </div>
              </div>
            ))}
        </div>

        <div className="flex lg:flex-row flex-col gap-[2.25rem]">
          <FundingSplitChart/>
          <AcresImpactChart/>
        </div>
      </div>
    </div>
  );
}

export default InvestmentBreakdown;
